import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { initSentry } from './lib/sentry';
import { initAnalytics, trackPageView } from './lib/analytics';
import { useAuthStore } from './stores/authStore';
import { useThemeStore } from './stores/themeStore';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Desktop } from './components/desktop/Desktop';
import './App.css';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

function App() {
  const { initialize } = useAuthStore();
  const initializeTheme = useThemeStore(state => state.initialize);

  useEffect(() => {
    initSentry();
    initAnalytics();
    initialize();
    initializeTheme();
  }, [initialize, initializeTheme]);

  return (
    <ErrorBoundary>
      <Router>
        <AnalyticsTracker />
        <Toaster position="top-right" toastOptions={{
          style: {
            background: '#0a0a0a',
            color: '#00ff41',
            border: '1px solid #00ff41',
            fontFamily: 'monospace',
          },
        }} />
        <Routes>
          <Route path="*" element={<Desktop />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
